import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import CompanyInfo from "../views/CompanyInfo";
import NewsList from "../views/NewsList";
import GameList from "../views/GameList";
import RecruitmentCenter from "../views/RecruitmentCenter";
import ContactUs from "../views/ContactUs";
import ParentalGuardianship from "../views/ParentalGuardianship";
import UserAgreement from "../views/UserAgreement";
import PrivacyPolicy from "../views/PrivacyPolicy";
import NewsDetail from "../views/NewsDetail";
import CareersDetail from "../views/CareersDetail";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/toHome"
  },
  { name: "Home", path: "/toHome", component: Home },
  { name: "CompanyInfo", path: "/toCompanyDetail", component: CompanyInfo },
  { name: "NewsList", path: "/toNewsList", component: NewsList },
  { name: "NewsDetail", path: "/NewsDetail/:newsId", component: NewsDetail },
  { name: "GameList", path: "/toGameList", component: GameList },
  {
    name: "RecruitmentCenter",
    path: "/toRecruitmentCenter",
    component: RecruitmentCenter
  },
  {
    name: "CareersDetail",
    path: "/toCareersDetail/:jobId",
    component: CareersDetail
  },
  { name: "ContactUs", path: "/toContactUs", component: ContactUs },
  {
    name: "ParentalGuardianship",
    path: "/toParentalGuardianship",
    component: ParentalGuardianship
  },
  { name: "UserAgreement", path: "/toUserAgreement", component: UserAgreement },
  { name: "PrivacyPolicy", path: "/toPrivacyPolicy", component: PrivacyPolicy }
];

// noinspection JSUnusedGlobalSymbols
const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
